import * as React from 'react';
import styled from 'styled-components';

import { Button } from '../material-ui';

const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin: 1rem 0;
`;

const StyledButton = styled(Button).attrs({
	variant: 'contained',
	size: 'large',
})`
	min-width: 0 !important;
	width: 4rem;
	height: 4rem;
	margin-right: 1rem !important;
	padding: 0 !important;
`;

class CategoryButton extends React.Component {
	handleClick = () => this.props.onSelected && this.props.onSelected(this.props);
	render = () => (
		<StyledButton color={this.props.color} onClick={this.handleClick}>
			{this.props.label}
		</StyledButton>
	);
}

export const CategorySelection = ({ categories, onCategorySelected, value }) => (
	<Wrapper>
		{categories.map((item) => (
			<CategoryButton
				key={item.value}
				{...item}
				onSelected={onCategorySelected}
				color={item.value === value ? 'primary' : 'default'}
			/>
		))}
	</Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/CategorySelection.js